<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <h3 :class="['subheading', 'font-grey', 'font-l-600']">Paragraph</h3>
    <vc-lorem-ipsum :repeats="1" tag="p" />
    <h3 :class="['subheading', 'font-grey', 'font-l-600']">Block quote</h3>
    <vc-lorem-ipsum :repeats="1" tag="blockquote" />
    <h3 :class="['subheading', 'font-grey', 'font-l-600']">Code</h3>
    <code>import Vuecidity from 'vuecidity'</code>
    <h3 :class="['subheading', 'font-grey', 'font-l-600']">Keyboard Input</h3>
    <kbd>import Vuecidity from 'vuecidity'</kbd>
    <h3 :class="['subheading', 'font-grey', 'font-l-600']">Variables</h3>
    <kbd>import Vuecidity from 'vuecidity'</kbd>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ContentPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/content.vue